
export function getRowPeriode(row) {
  return row?.periode ?? row?.semaine ?? row?.mois ?? "";
}

function pad(n) {
  return String(n).padStart(2, "0");
}

function parseMondayKey(periode) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(periode);
  if (!m) return null;
  const [, y, mo, d] = m.map(Number);
  const monday = new Date(y, mo - 1, d);
  return Number.isNaN(monday.getTime()) ? null : monday;
}

export function formatPeriode(periode, periodMode) {
  if (!periode) return "—";
  if (periodMode === "week") {
    const monday = parseMondayKey(periode);
    if (monday) {
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      return `${pad(monday.getDate())}/${pad(monday.getMonth() + 1)} – ${pad(sunday.getDate())}/${pad(sunday.getMonth() + 1)}/${sunday.getFullYear()}`;
    }
  }
  return periode;
}

export function getAggregatesForPeriod(data, population, periodMode) {
  if (!data) return { rows: [], weekUnavailable: false };

  if (periodMode === "week") {
    if (!data.aggregates_week) {
      return { rows: [], weekUnavailable: true };
    }
    return {
      rows: data.aggregates_week[population] || [],
      weekUnavailable: false,
    };
  }

  const monthSrc = data.aggregates_month || data.aggregates;
  return {
    rows: monthSrc?.[population] || [],
    weekUnavailable: false,
  };
}
